/*
 * Pawbau delivery line (snippets/pawbau-delivery.liquid): "Order today → arrives by Mon, Oct 12".
 * Today in the shop's time zone, plus the days to the door, moved to the next working day when it lands
 * on a weekend or a listed holiday. The cart drawer is redrawn after every change, so new or redrawn
 * lines are filled again as they appear.
 */
(() => {
  if (window.pawbauDelivery) return;
  window.pawbauDelivery = true;

  const DAY = 86400000;

  // the calendar day it is now in the shop's time zone, as a plain UTC date
  const shopToday = (zone) => {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: zone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).formatToParts(new Date());
    const get = (type) => Number(parts.find((p) => p.type === type)?.value);
    return Date.UTC(get('year'), get('month') - 1, get('day'));
  };

  const iso = (time) => new Date(time).toISOString().slice(0, 10);

  const working = (time, holidays) => {
    const weekday = new Date(time).getUTCDay();
    return weekday !== 0 && weekday !== 6 && !holidays.has(iso(time));
  };

  const nextWorking = (time, holidays) => {
    while (!working(time, holidays)) time += DAY;
    return time;
  };

  const label = (time) =>
    new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' }).format(
      new Date(time)
    );

  const fill = (line) => {
    const d = line.dataset;
    const holidays = new Set(
      (d.holidays || '')
        .split(',')
        .map((day) => day.trim())
        .filter(Boolean)
    );
    let order;
    try {
      order = shopToday(d.zone);
    } catch {
      return; // an unknown time zone: the plain line stays
    }

    const arrive = nextWorking(order + Number(d.days || 16) * DAY, holidays);
    const html = (d.template || '')
      .replace('[order]', `<b>${d.today || label(order)}</b>`)
      .replace('[arrive]', `<b>${label(arrive)}</b>`);

    const text = line.querySelector('[data-delivery-text]');
    // only when it differs, so filling a line does not wake the watcher below again
    if (text && html && text.innerHTML !== html) text.innerHTML = html;
  };

  const fillAll = () => document.querySelectorAll('[data-delivery]').forEach(fill);

  let queued = false;
  const soon = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      fillAll();
    });
  };

  const start = () => {
    fillAll();
    new MutationObserver(soon).observe(document.body, { childList: true, subtree: true, characterData: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', soon);
})();
